import{createContext}from"react";import noop from"lodash/noop";export const BurgerMenuContext=createContext({closeMenu:noop});